export const situations = [
  'Мы только что расстались',
  'Не могу отпустить',
  'Хочу вернуть отношения',
  'Мы продолжаем общаться',
  'Постоянно думаю о нём / о ней',
  'Накрывает тревога или паника',
  'Хочу понять, что делать дальше',
  'Боюсь снова написать / сорваться',
  'Другое',
]

export const recencyOptions = ['Сегодня–3 дня', 'До 2 недель', 'До 2 месяцев', 'Больше 2 месяцев']

export const promises = [
  'пережить острый момент через SOS',
  'обсуждать происходящее, помня контекст',
  'видеть, где вы на пути восстановления',
  'получать следующий шаг на сегодня и неделю',
]
